import BannerReducer from './BannerReducer';
import HomeReducer from './HomeReducer';
import BusReducer from './BusReducer';
import UiReducer from './UiReducer';
import EtravReducer from './EtravReducer';
import UserReducer from './UserReducer';
import TripjackReducer from './TripjackReducer';
import FDReducer from './FDReducer';

const rootReducer = {
	ui: UiReducer.reducer,
	banner: BannerReducer.reducer,
	home: HomeReducer.reducer,
	bus: BusReducer.reducer,
	etrav: EtravReducer.reducer,
	user: UserReducer.reducer,
	tripjack: TripjackReducer.reducer,
	promo: FDReducer.reducer,
};

export default rootReducer;
